module.exports = __webpack_public_path__ + "static/media/article101.dba05aa4.jpg";